<script lang="ts" setup>
	const props = defineProps<{
		date: string
		type?: 'staff' | 'dependant'
	}>()
	const activationDay = computed(() => {
		return new Date(new Date(props.date ?? '').getTime() + WAITING_PERIOD_5_DAYS)
	})
	const countdowns = useCountdown(activationDay.value)
</script>

<template>
	<div class="flex min-h-[361px] w-full items-center justify-center bg-[#2D43792E] p-3 backdrop-blur-[20px]">
		<div
			class="justify- flex min-h-[289px] w-full max-w-[400px] flex-col items-center rounded-[4.778px] bg-white py-10"
		>
			<h3 class="text-lg font-semibold text-primary-2 sm:text-xl">Waiting Period</h3>
			<p class="mt-2 text-center text-sm text-[#5F738C]">
				{{ type === 'dependant' ? 'This dependant’s' : 'Your' }} plan would become active in <br />
				<span class="font-medium text-primary-2">
					{{ countdowns?.days ?? 0 }} day{{ countdowns?.days > 1 ? 's' : '' }} :
					{{ countdowns?.hours ?? 0 }} hr{{ countdowns?.hours > 1 ? 's' : '' }} :
					{{ countdowns?.minutes ?? 0 }} min{{ countdowns?.minutes > 1 ? 's' : '' }}
					{{ countdowns?.seconds ?? 0 }} sec{{ countdowns?.seconds > 1 ? 's' : '' }}
				</span>
				.
			</p>

			<products-countdown wrapper-class="bg-warning-500 mt-5" :date="activationDay" />
		</div>
	</div>
</template>
